import { useContext } from "react";
import type { backendReportSurgicalSuggestionRowDTO } from "../../backend/target/typescript/dto";
import { RequestContext } from "../request-context";
import { requestGet, requireResult } from "../utils/network";
import { asNumber } from "../utils/strings";
import { getPeriodRange } from "../widget/i-period";
import { Modes } from "../widget/io-abstract";
import IONumber from "../widget/io-number";
import SearchPanel, { getPref, type FormValues } from "../widget/search-panel";
import TablePanel from "../widget/table-panel";

type ServerResponse = backendReportSurgicalSuggestionRowDTO[];

export default function ReportSurgicalSuggestion(): React.ReactNode {
  const requestContext = useContext(RequestContext)!;
  const onSearch = (formData: FormValues): Promise<React.ReactNode> =>
    requestContext
      .fetchJSONAndMessage<ServerResponse>(
        "Generating report",
        requestGet("/api/reports/surgical-suggestion", {
          ...formData,
          ...getPeriodRange("year", undefined, undefined, formData["year"])
        })
      )
      .then(requireResult)
      .then((list) => (
        <TablePanel
          rows={list}
          headers={
            <thead>
              <tr>
                <th></th>
                <th>Entry Number</th>
                <th>Name</th>
                <th>Birth</th>
                <th>Sex</th>
                <th>Pathology</th>
                <th>Last Appointment</th>
                <th>Last Surgery</th>
                <th>Suggested From</th>
              </tr>
            </thead>
          }
          lineLink={(row) =>
            `/patient/${row.patient_id}/patient/${row.patient_id}`
          }
          lineColumns={(row) => {
            return (
              <>
                <td>{row.patient_reference ?? ""}</td>
                <td>{row.patient_name ?? ""}</td>
                <td>{row.year_of_birth ?? ""}</td>
                <td>{row.sex ?? ""}</td>
                <td>{row.pathology ?? ""}</td>
                <td>{row.last_appointment ?? ""}</td>
                <td>{row.last_surgery ?? ""}</td>
                <td>{row.suggested_from ?? ""}</td>
              </>
            );
          }}
          reportBasename={`surgical-suggestions ${formData["year"]}`}
        />
      ));

  return (
    <div>
      <h1>
        <img src="/static/img/reports.gif" />
        Surgical Suggestion Report
      </h1>

      <SearchPanel
        form={
          <>
            <IONumber
              name="year"
              mode={Modes.input}
              value={asNumber(
                getPref("year", new Date().getFullYear().toString())
              )}
              required
              htmlProps={{ min: 1990, max: 2100 }}
            />
          </>
        }
        onSearch={onSearch}
      />
    </div>
  );
}
